import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'OBV' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'OBV', label: 'On-Balance Volume', pane: 'sub', params: [30], outputs: ['obv', 'maObv'], tailSafe: false })
